import { PartTimeScopeValueComponent } from './number/parttimescope-value-field.component';
import { CalendarModule } from 'primeng/calendar';
import { JobApplicationFieldComponent } from './jobapplication-field.component';
import { HisSharedModule } from 'hisng';
import { SalaryRequirementsFormComponent } from './number/salaryrequirements-form.component';
import { EarliestCommencementDateFormComponent } from './calendar/earliestcommencementdate-form.component';
import { PartTimeTypeFormComponent } from './autocomplete/parttimetype-form.component';
import { PartTimeFormComponent } from './checkbox/parttime-form.component';
import { NationalityFormComponent } from './autocomplete/nationality-form.component';
import { MaritalStatusComponent } from './autocomplete/maritalstatus-form.component';
import { BirthDateFormComponent } from './calendar/birthdate.component';
import { AdditionalNameComponent } from './input/additionalname-field.component';
import { SurnameComponent } from './input/surname-form.component';
import { FirstnameComponent } from './input/firstname-form.component';
import { TitleFormComponent } from './autocomplete/title-form.component';
import { GenderFormComponent } from './autocomplete/gender-form.component';
import { AcademicDegreeFormComponent } from './autocomplete/academic-degree-field.component';
import { NgModule } from '@angular/core';
import { CountryFormComponent } from './autocomplete/country-form.component';
import { EducationalAttainmentComponent } from './autocomplete/educational-attainment.component';
import { InformationSourceFormComponent } from './autocomplete/informationsource-field.component';
import { OfficialDesignationFormComponent } from './autocomplete/officialdesignation-form.component';
import { DisabilityFormComponent } from './checkbox/disability-field.component';
import { UnemployedFormComponent } from './checkbox/unemployed-field.component';
import { AdressSupplementComponent } from './input/adresssupplement-field.component';
import { CityComponent } from './input/city-field.component';
import { EmailAdressComponent } from './input/email-field.component';
import { MobileNumberComponent } from './input/mobilenumber-field.component';
import { PhoneNumberComponent } from './input/phonenumber-field.component';
import { PostcodeComponent } from './input/postcode-field.component';
import { StreetComponent } from './input/street-field.component';
import { DisabilityValueComponent } from './number/disability-value-field.component';
import { FinalGradeComponent } from './number/final-grade-field.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputNumberModule } from 'primeng/inputnumber';

@NgModule( {
    imports: [
        // Angular
        CommonModule,
        FormsModule,

        // PrimeNG
        AutoCompleteModule,
        InputNumberModule,
        CalendarModule,

        // HIS
        HisSharedModule,
    ],
    declarations: [
        AcademicDegreeFormComponent,
        GenderFormComponent,
        TitleFormComponent,
        FirstnameComponent,
        SurnameComponent,
        AdditionalNameComponent,
        BirthDateFormComponent,
        MaritalStatusComponent,
        NationalityFormComponent,
        PartTimeFormComponent,
        PartTimeTypeFormComponent,
        PartTimeScopeValueComponent,
        EarliestCommencementDateFormComponent,
        SalaryRequirementsFormComponent,
        OfficialDesignationFormComponent,
        UnemployedFormComponent,
        DisabilityFormComponent,
        DisabilityValueComponent,
        EducationalAttainmentComponent,
        FinalGradeComponent,
        AcademicDegreeFormComponent,
        InformationSourceFormComponent,
        StreetComponent,
        PostcodeComponent,
        CityComponent,
        EmailAdressComponent,
        MobileNumberComponent,
        PhoneNumberComponent,
        AdressSupplementComponent,
        CountryFormComponent,
        JobApplicationFieldComponent,
    ],
    exports: [
        JobApplicationFieldComponent,
    ],
} )
export class JobApplicationFieldsSharedModule {

}
